import {React, useState, useEffect } from "react";
import { FxmsData } from "../../fxms/datas/FxData";
import MuiTable from "../common/MuiTable";
import { energyOptions, intervalOptions, methodOptions, variableOptions } from "../common/commonVal";
import { getToday, getDay, getInloInfo} from "../common/commonMethod";
import { UI_1_4_gridData1, UI_1_4_gridData2, UI_1_4_tableRow1, UI_1_4_tableRow2 } from "./UI_1_4.helper";

/**
 * @description 수요공급예측 > 예측변수조회
 * @author CHOISEONHA
 * @date 04/12/2024
 * @param {*}
 * @return  수요공급예측 > 예측변수조회
 */

export const UI_1_4 = () => {
  const [pageSize, setPageSize] = useState(25);
  const handlePageSizeChange = (newPageSize) => {
      setPageSize(newPageSize);
  };
  const user = FxmsData.getUser();
  const inlo = getInloInfo(FxmsData.getInlo(user.inloNo),user);
   
  const [fetchComplexInlo, setFetchComplexInlo] = useState([]);
  const [fetchCompanyInlo, setFetchCompanyInlo] = useState([]);
  const [fetchPlantInlo, setFetchPlantInlo] = useState([]);
  const [onePlant, setOnePlant] = useState(null);
  const [selected, setSelected] = useState({
    complexInloNo: user.ugrpNo === 1021||user.ugrpNo === 1024? inlo.complexInloNo : "",
    companyInloNo:user.ugrpNo === 1024? inlo.companyInloNo : "",
    plantInloNo: user.ugrpNo === 1024? inlo.inloNo : "",
    method: "prod",
    energy: "AIR",
    interval: "day",
    startDate: getDay(-7),
    endDate:  getToday(),
    variable: "",
  });
  const [fetchData, setFetchData] = useState([]);


  useEffect(()=> {
    if (user.inloClCd === "PROJECT" || user.inloClCd === "COMPLEX") {
      getComplexInloData();
    } else {
      getPlantInloData(user.inloNo);
    }
  }, []);

  // complexInloNo가 설정되면 회사 목록을 가져오도록 useEffect 추가
  useEffect(() => {
    if (selected.complexInloNo) {
      selectedComplex(selected.complexInloNo);
    }
  }, [selected.complexInloNo]);

  useEffect(()=>{
    console.log("selected :::: >>>" , selected);
  }, [selected])

  useEffect(()=>{
    selectedComplex(selected.complexInloNo);
  },[selected.method, selected.energy])

  useEffect (() => {
    if (onePlant) {
      setSelected((prev) => ({ ...prev, plantInloNo: onePlant.inloNo }));
    }
  },[onePlant]);

  const getComplexInloData = async () => {
    const uri = "vup/getComplexInloList"
    try {
      const res = await FxmsData.GET(uri);
      if(user.inloClCd === "PROJECT") {
        setFetchComplexInlo(res.data);
      } else {
        setFetchComplexInlo(res.data[0]);
        setSelected((prev) => {
          return { ...prev, complexInloNo: res.data[0].inloNo };
        });
      }
      console.log("complex List >> ", res.data);
    } catch (e) {
      console.log("getComplexInloList error ........", e);
    }
  }

  // 공장로그인 일 경우, 해당 공장만 조회
  const getPlantInloData = async (value) => {
    const uri = "vup/getPlant/" + value;
    try {
      const res = await FxmsData.GET(uri);
      setOnePlant(res.data);
      console.log("getPlant .. >", res.data[0]);
    } catch (e) {
      console.log("getPlant error..", e);
    }
  }


  const selectedComplex = async (value) => {
    console.log("선택된 산단번호 ::", value);
    setSelected((prev) => ({ ...prev, complexInloNo: value }));
    const uri = "vup/getCompanyInloListNew";

    const param = {
      energy: selected.energy,
      sourceSink: selected.method ==='cons'? 'SINK':'SOURCE',
      complexInloNo: value,
    }

    try {
      const res = await FxmsData.GET(uri, param)
      setFetchCompanyInlo(res.data);
      setFetchPlantInlo([]); // 산단을 변경하면 plantInlo를 초기화
      console.log("company List >>", res.data);
    } catch (e) {
      console.log("getCompanyInloList error.... ", e);
    }
  }

  const selectedCompany = async (value) => {
    console.log("선택된 회사번호 :: ", value);
    setSelected((prev) => ({ ...prev, companyInloNo: value }));
    const uri = "vup/getPlantInloList/" + value;
    try {
      const res = await FxmsData.GET(uri);
      setFetchPlantInlo(res.data);
      setSelected((prev) => {
        return { ...prev, plantInloNo: res.data[0].inloNo };
      });
      console.log("plant List >>", res.data);
    } catch (e) {
      console.log("getPlantInloList error.... ", e);
    }
  }

  const selectedPlant = (value) => {
    setSelected((prev) => ({ ...prev, plantInloNo: value }));
  }

  const handleSelectData = (event) => {
    const { id, value, name } = event.target;
    setSelected((prev) => {
      return { ...prev, [name]: value };
    })
  }

  const selectedInterval = (e) => {
    const value = e.target.value;
    setSelected((prev) => ({...prev, interval: value}));
  }

  // 조회 버튼 클릭 시 데이터 GET 함수
  const submitBtnClick = async () => {
    const params = {
      startDate: selected.startDate,
      endDate: selected.endDate,
      method: selected.method,
      energy: selected.energy,
      interval: selected.interval,
      complexInloNo: selected.complexInloNo,
      companyInloNo: selected.companyInloNo,
      plantInloNo: selected.plantInloNo
    };

    try {
      const res = await FxmsData.GET('vup/select_1_2', params);
      if (res.status === 200) { // axios 사용 시 response 상태 검사
        console.log("response.data"); // 서버 응답 출력
        setFetchData(res.data);
      } else {
        console.error('Error:', res.status); // 오류 상태 출력
      }
    } catch (error) {
      console.error('Network error:', error); // 네트워크 오류 출력
    }
  };



  return (
    <>
    <div className="predict">
      {/*  
      <div className="FxCrudFilter">
        <div className="FxFilterLeft">
            <label className="FxLabelSearch"></label>
            <select className="FxSelectSearch" name="energy" onChange={handleSelectData}>
              {energyOptions.map((item, index) => (
                <option key={index} value={item.value} name="energy">{item.label}</option>
              ))}
            </select>
            <label className="FxLabelSearch"></label>
            <select className="FxSelectSearch" name="method" onChange={handleSelectData}>
              {methodOptions.map((item, index) => (
                <option key={index} value={item.value} name="method">{item.label}</option>
              ))}
            </select>
            <label className="FxLabelSearch"></label>
            {user.ugrpNo === 1024 ?
              null :
            <select className="FxSelectSearch" onChange={(e) => selectedComplex(e.target.value)}>
              {user.inloClCd === "PROJECT" ?
                <>
                  <option value="">산업단지 전체</option>
                  {fetchComplexInlo.map((item) => (
                    <option key={item.inloNo} value={item.inloNo} name="complexInloNo">
                      {item.inloName}
                    </option>
                  ))}
                </>
              :
                <option value={fetchComplexInlo.inloNo}> {fetchComplexInlo.inloName} </option>
              }
            </select>
            }
            <label className="FxLabelSearch"></label>
            {user.ugrpNo === 1024 ?
              null :
            <select className="FxSelectSearch" onChange={(e) => selectedCompany(e.target.value)}>
                <option value="">회사 전체</option>
                {fetchCompanyInlo.map((item) => (
                  <option key={item.inloNo} value={item.inloNo} name="companyInloNo">
                    {item.inloName}
                  </option>
                ))}
            </select>
            }
            <label className="FxLabelSearch"></label>
            {user.ugrpNo === 1024 ?
              <select className="FxSelectSearch">
                {onePlant && <option key={onePlant.inloNo} value={onePlant.inloNo} name="plantInloNo">
                  {onePlant.inloName}
                </option>}
              </select>
              :
              <select className="FxSelectSearch" onChange={(e) => selectedPlant(e.target.value)}>
                <option value="">사업장 전체</option>
                {fetchPlantInlo?.map((item) => (
                  <option key={item.inloNo} value={item.inloNo} name="plantInloNo">
                    {item.inloName}
                  </option>
                ))}
              </select>
            }
            <label className="FxLabelSearch"></label>
            <select className="FxSelectSearch" name="variable" onChange={handleSelectData}>
              <option value="">변수 전체</option>
                {variableOptions.map((item, index) => (
                  <option key={index} value={item.value} name="variable">{item.label}</option>
                ))}
            </select>
        </div>
        <div className="FxFilterRight">
          <input className="FxDate" type="date" name="startDate" value={selected.startDate}  onChange={handleSelectData} />
          <label className="FxLabelSearch">~</label>
          <input className="FxDate" type="date" name="endDate" value={selected.endDate} onChange={handleSelectData} />
          <input className="FxButtonSearch" type="button" value="조회" onClick={submitBtnClick}/>
        </div>
      </div>
{/*       
      <div class="FxCrudDataGrid">
        <div class="FxDataTitle">제품생산량</div>
        <div class="chartOption">
          <div class="charOptionLeft">
              {intervalOptions.map((option, index) => (
                <>
                <input type="radio" id={option.value} name="interval" value={option.value} onChange={(e) => selectedInterval(e)} checked={selected.interval === option.value}/>
                <label>{option.label}</label>
                </>
              ))}
          </div>
          
        </div>
      </div> 
 */}
      
      <div className="FxCrudDataGrid">
        <div class="FxMuiTable">
          <MuiTable
            tableRowDataList={
              selected.interval === "realtime" ? UI_1_4_tableRow1 : UI_1_4_tableRow1
            }
            rows={
              selected.interval === "realtime" ? UI_1_4_gridData1 : UI_1_4_gridData1
            }
            menuFullName='수요예측/예측변수조회'
            initialRowsPerPage={30}
          />
        </div>
      </div>
    </div>
    </>
  )
}